import api from '../core/api';

const findAll = async () => {
  const result = await api.get('/empresas');
  const empresas = result.data;
  return empresas;
};

export default {findAll};
